import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from "../services/auth/auth.service";
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { SocialAuthService, GoogleLoginProvider, SocialUser } from '@abacritt/angularx-social-login';
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "../../environments/environment";

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class LoginComponent implements OnInit {
	COBRA_PORTAL_BASE_UI_URL = environment.COBRA_PORTAL_BASE_UI_URL;
	COBRA_portal_window: any;
	socialUser: SocialUser | undefined;
	isLoggedin = false;
	processing = false;
	user_email = '';
	logo = '';
	ignite = false;
	isPyrocast = true;
	constructor(fb: UntypedFormBuilder,
		private router: Router,
		private authService: AuthService,
		private _snackBar: MatSnackBar,
		private route: ActivatedRoute,
		private socialAuthService: SocialAuthService,
		private http: HttpClient) {
		if (window.location.hostname == environment.skyDomain) {
			this.logo = 'skystream_logo.png';
			this.isPyrocast = false;
		}
		else if(window.location.hostname == environment.igniteDomain){
			this.logo = 'IGNITE_Live_Logo_login_page.png';
			this.isPyrocast = false;
			this.ignite = true;
		}
		else if (window.location.hostname == environment.tune2Domain || window.location.hostname == environment.tune2Domain2) {
			this.logo = 'tune2-logo.webp';
			this.isPyrocast = false;
		}
		else {
			this.logo = 'pyrocast-logo-new.webp';
		}
		this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
		this.route.queryParams
			.subscribe(params => {
				if (params.email) {
					this.user_email = params.email;
				}
			}
			);
	}

	ngOnInit(): void {
		window.addEventListener("message", (event: MessageEvent) => this.handleIncomingMessages(event));
		this.google_login();
	}

	apple_login() {
		this.authService.apple_login().then((data: any) => {
			if (data.authorization) {
				this.processing = true;
				let params: any = { token: data.authorization.code, user_data: data.user, source: 'APPLE', origin: window.location.hostname };
				if (this.user_email) {
					params.user_email = this.user_email;
				}
				this.authService.apiLogin(params).subscribe(response => {
					this.authService.login(response);
				});
			}
			else {
				this._snackBar.open('Error signing in with Apple. Try again', 'Close');
			}
		});
	}
	google_login(): void {
		this.socialAuthService.authState.subscribe((user) => {
			this.processing = true;
			let params: any = { token: user.idToken, source: 'GOOGLE' };
			if (this.user_email) {
				params.user_email = this.user_email;
			}
			this.authService.apiLogin(params).subscribe(response => {
				this.authService.login(response);
			});
		}, (error: any) => {
			this._snackBar.open('Error signing in with Google. Try again', 'Close');
		});
	}

	logout(): void {
		this.authService.logout();
	}
	cobraLogin() {
		const url = `https://portal.cobrafiringsystems.com/login?originating_cobra_platform=PYROCAST&send_token_using=WINDOW_MESSAGE`;
		console.log(url);

		let window_width = 700;
		let window_height = 900;
		let left = (screen.width - window_width) / 2;
		let top = (screen.height - window_height) / 2;

		this.COBRA_portal_window = window.open(url, 'elevate_studio_login_window', 'width=' + window_width + ',height=' + window_height + ',left=' + left + ',top=' + top + ',resizable=yes');
		// this.COBRA_portal_window.close();
	}

	handleIncomingMessages(event: MessageEvent) {
		console.log(1)
		if (event.origin !== this.COBRA_PORTAL_BASE_UI_URL && event.origin !== 'https://portal.cobrafiringsystems.com') return;
		console.log(event.data)
		if (event.data?.title === 'COBRA_PORTAL_user_login_tokens') {
			this.COBRA_portal_window?.postMessage({ title: 'COBRA_PORTAL_user_login_tokens_received' }, event.origin);
			this.validateCOBRAPortalLogin(event.data.access_token, event.data.refresh_token);
		}
	}
	validateCOBRAPortalLogin(access_token: string, refresh_token: string) {

		if (!access_token) {
			console.error('Missing access_token');
			return;
		}

		this.http.post<any>(
			`${environment.apiUrl}/users/cobraportal`,
			{ access_token, refresh_token }
		).subscribe({
			next: (res) => {

				localStorage.setItem('token', res.token);

				if (refresh_token) {
					localStorage.setItem('refresh_token', refresh_token);
				}

				localStorage.setItem('offline_user_info', JSON.stringify(res.user));

				// popup close
				if (this.COBRA_portal_window && !this.COBRA_portal_window.closed) {
					this.COBRA_portal_window.close();
				}

				// redirect
				this.router.navigate(['/home']);
				console.log('COBRA login success', res);
			},
			error: (err) => {
				console.log('COBRA login failed', err);
				this.COBRA_portal_window.close();
				this._snackBar.open('Your account does not have access to the COBRA Portal.','Close',{ duration: 5000 });

			}
		});
	}

}
